<template>
    <div class="index">
        <div class="index_cont">
            <!--        <img :src="require('../../assets/index/facula.png')" alt="" class="bgF">-->
            <!--        <div class="bgFacula"></div>-->
            <img :src="require('@/assets/index/logo_main.png')" alt="" class="index_logo">
            <img :src="require('@/assets/index/title.png')" alt="" class="index_title">
            <div class="index_main">
                <img @click="goNext" :src="require('../../assets/index/btn_now.png')" alt="" class="index_btn_left">
                <img @click="goRule" :src="require('../../assets/index/btn_rule.png')" alt="" class="index_btn_right">
            </div>
        </div>

    </div>
</template>

<script>
  export default {
    data(){
      return {

      }
    },
    methods:{
      goRule(){
        this.$router.push({path: '/rule'})
      },
      goNext(){
        this.$router.push({path: '/home'})
      }
    }
  }
</script>

<style scoped lang="less">
    .index{
        width: 100%;
        height: 100%;
        background-image: url('../../assets/index/bg.png');
        background-size: cover;
        background-position: 50%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        position: relative;
        overflow: auto;
        .index_cont{
            padding-top: 94px;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            background-image: url("../../assets/index/facula.png");
            background-size: cover;
            background-position: 50%;
            background-repeat: no-repeat;
            .bgFacula{
                width: 100%;
                height: 100%;
                background-image: url('../../assets/index/facula.png');
                background-size: cover;
                background-position: 50%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
            }
            .bgF{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
            }
            .index_logo{
                width: 110px;
                height: 85px;
                margin: 0 auto 15px;
            }
            .index_title{
                width: 303px;
                height: 50px;
                margin: 0 auto;
            }
            .index_main{
                width: 100%;
                height: 350px;
                background-image: url('../../assets/index/girl.png');
                background-position: 0 0;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                .index_btn_left{
                    width: 155px;
                    height: 36px;
                    margin-right: 15px;
                }
                .index_btn_right{
                    width: 137px;
                    height: 36px;
                }
                .index_btn_left:active, .index_btn_right:active{
                    opacity: 0.8;
                }
            }
        }

    }
</style>
